export const SM_TEMPLATES_API = "/smtemplate";
export const GET_ASSETS_API = "/assets/link/";
